import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import forgot from "../../assets/images/icon_login/forgot-password.svg";
import TabsMobile from "../__template/TabsMobileComponent";

const ComponentForgotPassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [supportOpened, setSupportOpened] = useState(false);
  const [broadcastOpened, setBroadcastOpened] = useState(false);
  const [supportMessage, setSupportMessage] = useState("");
  const [supportUsername, setSupportUsername] = useState("");
  const [supportInstitute, setSupportInstitute] = useState("");

  function openSupport() {
    setSupportOpened(true);
  }

  function closeSupport() {
    setSupportOpened(false);
  }

  function sendMessage() {
    console.log(supportMessage);
    let url = "";
    let phone = "6281326269992";
    url =
      "https://wa.me/" +
      phone +
      "?text=Halo,%20saya%20" +
      supportUsername +
      "%20dari%20" +
      supportInstitute +
      "%20menemui%20kendala%20sebagai%20berikut:%0A%0A" +
      supportMessage;
    setSupportOpened(false);
    window.open(url, "_blank");
  }
  return (
    <div className="min-h-screen h-full px-10 py-7 bg-psp-primary">
      <TabsMobile
        name={`${t("FORGOT-PASSWORD.title")}`}
        backUrl={"login"}
      ></TabsMobile>
      <section className="relative flex flex-col top-to-bottom">
        <img src={forgot} className="mt-4" />
        <h1 className="font-montserrat font-bold text-center text-4xl text-black my-4">
          {t("FORGOT-PASSWORD.subtitle")}
        </h1>
        <ol className="font-montserrat list-decimal text-psp-gray text-xs mb-0 ">
          <li>
            {t("FORGOT-PASSWORD.step.one")}{" "}
            <span className=" text-psp-primary" onClick={() => openSupport()}>
              {t("LOGIN.cs")}
            </span>
          </li>
          <li>{t("FORGOT-PASSWORD.step.two")}</li>
          <li>{t("FORGOT-PASSWORD.step.three")}</li>
          <li>{t("FORGOT-PASSWORD.step.four")}</li>
        </ol>
        <div className="mt-2 font-montserrat">
          <span className="text-psp-gray text-xs px-2">
            {t("FORGOT-PASSWORD.term.title")}
          </span>
          <ol className="list-decimal text-psp-gray text-xs">
            <li> {t("FORGOT-PASSWORD.term.one")}</li>
            <li>{t("FORGOT-PASSWORD.term.two")}</li>
          </ol>
          <button
            onClick={() => navigate("/forgot-password-confirmation")}
            className="mt-2 bg-psp-btn-primary text-white font-bold w-full py-2 rounded-lg hover:text-red-600 hover:ring-2 hover:ring-offset-cyan-600  active:bg-psp-active"
          >
            {t("FORGOT-PASSWORD.next")}
          </button>
        </div>
      </section>
      {/* <section className="flex flex-col mt-14">
          <h1 className="font-montserrat m-0 font-bold text-sm text-black text-center">
            Reset Password
          </h1>
          <p className="font-montserrat mt-2 font-medium text-xs text-black text-center">
            Kami telah mengirim 6 digit kode. Silahkan masukan untuk mereset
            passwordmu
          </p>
          <h1 className="font-montserrat m-0 font-bold text-sm text-black text-center">
            Masukkan Kode
          </h1>
          <hr />
          <h1 className="font-montserrat m-0 font-medium text-sm text-black text-center">
            Silahkan kirimkan ke whatsapp dan email yang{" "}
            <span className="text-red-600">sudah terdaftar</span>
          </h1>
          <button className="mt-2 bg-psp-btn-primary text-white font-bold w-full py-2 rounded-lg hover:text-red-600 hover:ring-2 hover:ring-offset-cyan-600  active:bg-psp-active">
            Kirim OTP
          </button>
        </section> */}
      <Transition appear show={supportOpened} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={closeSupport}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-psp-primary p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    <div>{t("CUSTOMER.title")}</div>
                  </Dialog.Title>
                  <div className="mt-2">
                    <input
                      onChange={(e) => setSupportUsername(e.target.value)}
                      placeholder={`${t("CUSTOMER.name")}`}
                      className="w-full py-1 px-2.5 rounded-lg"
                    />
                  </div>
                  <div className="mt-2">
                    <input
                      onChange={(e) => setSupportInstitute(e.target.value)}
                      placeholder={`${t("CUSTOMER.institution")}`}
                      className="w-full py-1 px-2.5 rounded-lg"
                    />
                  </div>
                  <div className="mt-2">
                    <textarea
                      onChange={(e) => setSupportMessage(e.target.value)}
                      placeholder={`${t("CUSTOMER.message")}`}
                      className="w-full py-1 px-2.5 rounded-lg"
                    ></textarea>
                  </div>
                  <div className="mt-4 flex flex-row justify-evenly">
                    <button
                      type="button"
                      className="w-full h-10 mr-1 rounded-md text-white bg-psp-btn-red"
                      onClick={closeSupport}
                    >
                      {t("CUSTOMER.no")}
                    </button>
                    <button
                      type="button"
                      className="w-full h-10 ml-1 rounded-md text-white bg-psp-btn-primary"
                      onClick={sendMessage}
                    >
                      {t("CUSTOMER.yes")}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
};

export default ComponentForgotPassword;
